import React, { useEffect } from 'react';
import { Icon } from '@gerdau/hefesto';
import { useDispatch } from 'react-redux';
import { SpinnerIcon } from '../../../../../../../components/Commons/SpinnerIcon/styles';
import { ErrorIcon } from '../../../../../../../components/Commons/Tables/DownloadCellContent/styles';
import {
  downloadShippingNoteFile,
  loadShippingNoteFile
} from '../../../../../../../store/ducks/long-steel-orders/actions';
import {
  IBilledOrderData,
  IDownloadNFEResponse
} from '../../../../../../../store/ducks/long-steel-orders/types';
import { IconWrapper, Link } from './styles';
import {
  RcaKind,
  sendRcaLogs
} from '../../../../../../../store/ducks/observability/actions';

interface ShippingNoteColumnProps {
  item: IBilledOrderData;
}

const ShippingNoteColumn: React.FC<ShippingNoteColumnProps> = ({ item }) => {
  const dispatch = useDispatch();

  const downloadFromUseEffect = () => {
    if (item.shippingNoteState) {
      dispatch(downloadShippingNoteFile(item));
      downloadFile(
        item.shippingNoteState.downloadNFEResponse as IDownloadNFEResponse
      );
    }
  };

  useEffect(() => {
    if (
      item.shippingNoteState &&
      !item.shippingNoteState.alreadyDownloaded &&
      item.shippingNoteState.downloadNFEResponse
    ) {
      downloadFromUseEffect();
    }
  });
  const downloadShippingNote = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    if (item.shippingNoteState && item.shippingNoteState.downloadNFEResponse) {
      downloadFile(item.shippingNoteState.downloadNFEResponse);
    } else {
      dispatch(loadShippingNoteFile(item));
      dispatch(sendRcaLogs(RcaKind.DownloadItem, 'SNF', item.id));
    }
  };

  const downloadFile = (downloadNFEResponse: IDownloadNFEResponse) => {
    const dataurl = 'data:text/plain;base64,' + downloadNFEResponse.FILE;
    const element = document.createElement('a');
    element.setAttribute('href', dataurl);
    element.setAttribute('download', `nota-remessa-${item.invoiceZvoi}.pdf`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <>
      {item.deliveryDocumentZvoi &&
        !item.shippingNoteState?.loading &&
        !item.shippingNoteState?.error && (
          <IconWrapper onClick={downloadShippingNote}>
            <Icon option="Download" variant="primary" size="sm" />
            <Link onClick={downloadShippingNote}>
              {Number(item.invoiceZvoi).toString()}
            </Link>
          </IconWrapper>
        )}

      {!item.deliveryDocumentZvoi && <IconWrapper>-</IconWrapper>}

      {item.shippingNoteState?.loading && (
        <>
          <SpinnerIcon style={{ margin: '0.125rem' }} />
          Baixando
        </>
      )}

      {!item.shippingNoteState?.loading && item.shippingNoteState?.error && (
        <>
          <ErrorIcon />
          {Number(item.invoiceZvoi).toString() && (
            <>
              {Number(item.invoiceZvoi).toString()}
              <br />
            </>
          )}
          Tentar novamente
        </>
      )}
    </>
  );
};

export default ShippingNoteColumn;
